import { api } from "@/lib/api";

export function pct(v, digits = 1) {
  if (v == null || isNaN(v)) return "—";
  return `${(v * 100).toFixed(digits)}%`;
}

export function eur(v, digits = 0) {
  if (v == null || isNaN(v)) return "—";
  return v.toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: digits, minimumFractionDigits: digits });
}

export function num(v, digits = 0) {
  if (v == null || isNaN(v)) return "—";
  return v.toLocaleString("fr-FR", { maximumFractionDigits: digits });
}

export function useKpiFilters() {
  return api.get("/kpi/filters").then(r => r.data);
}

/**
 * Convert the frontend multi-select filter shape into query params for the backend.
 * Backend accepts CSV-joined arrays via `drs`, `bms`, `corners`, `secteurs`, `enseignes`, `annees`, `mois`
 * plus `year_mode` (civil|fiscal).
 */
export function toParams(f = {}) {
  const p = {};
  // All array-based filters accepted by the backend (comma-joined)
  const arrayKeys = ["drs", "bms", "corners", "secteurs", "enseignes", "mois", "regions", "marques", "types"];
  arrayKeys.forEach(k => {
    if (Array.isArray(f[k]) && f[k].length > 0) p[k] = f[k].join(",");
  });
  if (Array.isArray(f.annees) && f.annees.length > 0) p.annees = f.annees.join(",");
  if (Array.isArray(f.semaines) && f.semaines.length > 0) p.semaines = f.semaines.join(",");
  if (Array.isArray(f.exercices) && f.exercices.length > 0) p.exercices = f.exercices.join(",");
  if (Array.isArray(f.jours) && f.jours.length > 0) p.jours = f.jours.join(",");
  if (f.year_mode) p.year_mode = f.year_mode;
  if (f.date_from) p.date_from = f.date_from;
  if (f.date_to) p.date_to = f.date_to;
  return p;
}

export function fyLabel(y) {
  return `FY${String(y).slice(-2)}`;
}
